const weui = window.weui

export const Builder = fetch => {
    return options => {
        if (fetch && options) {
            fetch(options.data).then(res => {
                if (options.success) options.success(res)
            }).catch(e => {
                if (options.fail) options.fail(e)
                else weui.alert(e)
            })
        }
    }
}